// This composable handles query param updates and navigation

export const useNavigation = () => {
    const router = useRouter()
    const route = useRoute()

    const currentPath = computed(() => route.path)
    const queryParams = computed(() => route.query || {})
    const routeParams = computed(() => route.params || {})
    const routeMeta = computed(() => route.meta || {})

    const putQueryParams = (query = {}) => {

        router.replace({
            path: route.path,
            query
        })
    }

    const patchQueryParams = (query = {}) => {
        router.replace({
            query: {
                ...queryParams.value,
                ...query
            }
        })
    }

    const deleteQueryParam = (queryParamKey) => {
        const newQueryParams = { ...queryParams.value }
        delete newQueryParams[queryParamKey]
        router.replace({
            query: newQueryParams
        })
    }

    const navigateTo = (path = currentPath.value, query) => {
        router.push({
          path,
          query: query ?? queryParams.value,
        })
      }

    const navigateBack = () => {
        if (router.options.history.state?.back) {
            router.back()
        } else {
            const path = '/'
            router.replace(path)
        }
    }

    return {
      currentPath,
      queryParams,
      routeParams,
      routeMeta,
      patchQueryParams,
      putQueryParams,
      deleteQueryParam,
      navigateTo,
      navigateBack,
    };
}
